import React, { useContext, useState } from "react";

import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

import notification from "../../../assets/images/notification.png";
import Button from "../../../components/Button";
import theme from "../../../constants/theme";
import ConfirmationModal from "../../../components/ConfirmationModal";
import { HospitalSurvey } from "../../../types/hospital";
import { confirmSurvey } from "../../../api/hospital";
import { UserContext } from "../../../Routes";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      background: theme.palette.secondary.light,
      padding: theme.spacing(0, 2),
      marginTop: theme.spacing(5),
      alignItems: "center",
      [theme.breakpoints.only("xs")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: theme.spacing(2),
      },
    },
    img: {
      width: "3rem",
      marginRight: theme.spacing(2),
    },
  })
);

type OldDataNotificationProps = {
  surveyData: HospitalSurvey;
  handleDataChange: (surveyData: HospitalSurvey) => void;
};

export default function OldDataNotification({
  surveyData,
  handleDataChange,
}: OldDataNotificationProps) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { user } = useContext(UserContext);

  return (
    <div className={classes.root}>
      <img src={notification} alt="notification" className={classes.img} />
      <div style={{ flexDirection: "column" }}>
        <Typography variant="body2">Vaši podaci su zastarjeli.</Typography>
        <Typography>
          Kliknite na gumb "Potvrdi" kako biste potvrdili ažurnost podataka.
        </Typography>
      </div>
      <div style={{ flexGrow: 1 }} />
      <Button
        startIcon={<CheckRoundedIcon />}
        onClick={() => {
          setModalOpen(true);
        }}
      >
        Potvrdi
      </Button>
      <ConfirmationModal
        modalOpen={modalOpen}
        handleClose={() => {
          setModalOpen(false);
        }}
        handleAction={async () => {
          await confirmSurvey();
          setModalOpen(false);
          handleDataChange({
            ...surveyData,
            lastUpdate: new Date().toString(),
            status: "APPROVED",
            userName: user?.name || "",
            userSurname: user?.surname || "",
          });
        }}
        modalText={
          "Molimo da provjerite točnost podataka prije potvrde. " +
          'Klikom na "U redu" potvrdit ćete ažurnost podataka o ustanovi.'
        }
        title={"Jeste li sigurni?"}
      />
    </div>
  );
}
